import { type PrinterPages } from '@justomx/atlas-components'
import { useNavigate } from 'react-router-dom'
import { toastSuccess } from 'utils/toast'

export const usePrinter = () => {
  const navigate = useNavigate()

  const onPrinterPageChange = (page: PrinterPages) => {
    if (page === 'DETAIL_PAGE') {
      toastSuccess('La impresora se ha sincronizado con tu handheld.')
      navigate(-1)
    }
  }

  const goBack = () => {
    navigate(-1)
  }

  return {
    actions: {
      onPrinterPageChange,
      goBack
    }
  }
}
